import React from "react";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormHomeHeaderSection from "../../components/home-header/FormHomeHeaderSection";
import { useGetHomeHeaderSection } from "../../hooks/home-header/useGetHomeHeaderSection";
import { useUpdateHomeHeaderSection } from "../../hooks/home-header/useUpdateHomeHeaderSection";

const HomeHeaderSection = () => {
    const { homeHeaderSection, isLoading: isFetching } = useGetHomeHeaderSection();
    const { mutate, isPending: isUpdating } = useUpdateHomeHeaderSection();

    const handleSubmit = (data) => {
        mutate(data);
    };

    if (isFetching) return null;

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormHomeHeaderSection
                currentData={homeHeaderSection}
                onSubmit={handleSubmit}
                isLoading={isUpdating}
            />
        </WrapperSection>
    );
};

export default HomeHeaderSection;
